{
	"name": "cbta-frontend",
	"version": "2.5.1931",
	"scripts": {
		"ng": "ng",
		"start": "npx http-server -p 4200  ./dist/cbta-frontend/browser",
		"start:dev": "ng serve",
		"build": "ng build",
		"build:dev": "ng build --configuration=dev",
		"build:stg": "ng build --configuration=staging",
		"build:prd": "ng build --configuration=production",
		"watch": "ng build --watch --configuration development",
		"test": "ng test",
		"test:ci": "ng test --watch=false --browsers=ChromeHeadless",
		"test:auth": "ng test --configuration=auth --watch=false --browsers=ChromeHeadless",
		"format": "prettier --write './src/**/*.{js,ts,html,css,scss}'",
		"kms:encrypt": "node scripts/kms-env.js encrypt",
		"kms:encrypt:prd": "node scripts/kms-env.js encrypt --env=prd",
		"kms:decrypt": "node scripts/kms-env.js decrypt",
		"kms:decrypt:dev": "node scripts/kms-env.js decrypt --env=dev",
		"kms:decrypt:stg": "node scripts/kms-env.js decrypt --env=stg",
		"kms:decrypt:prd": "node scripts/kms-env.js decrypt --env=prd",
		"kms:diagnose": "node scripts/kms-diagnose.js",
		"verify:bff-prod": "node scripts/verify-bff-prod-config.js"
	},
	"private": true,
	"engines": {
		"node": ">=22"
	},
	"dependencies": {
		"@angular/animations": "22.1.0",
		"@angular/cdk": "^22.1.1",
		"@angular/common": "22.1.0",
		"@angular/compiler": "22.1.0",
		"@angular/core": "22.1.0",
		"@angular/forms": "22.1.0",
		"@angular/material": "^22.1.1",
		"@angular/platform-browser": "22.1.0",
		"@angular/platform-browser-dynamic": "22.1.0",
		"@angular/pwa": "^22.1.3",
		"@angular/router": "22.1.0",
		"@angular/service-worker": "22.1.0",
		"@danielmoncada/angular-datetime-picker": "^21.0.0",
		"@fontsource/dm-sans": "^5.0.21",
		"@fontsource/material-icons": "^5.0.21",
		"@fontsource/material-symbols-outlined": "^5.0.21",
		"@fontsource/roboto": "^5.0.21",
		"angular-animations": "^0.11.0",
		"buffer": "^6.0.3",
		"chart.js": "^4.5.0",
		"crypto-js": "^4.2.0",
		"fuse.js": "^7.1.0",
		"lodash": "^4.17.21",
		"moment": "^2.30.1",
		"ngx-easy-table": "^15.7.0",
		"ngx-indexed-db": "^22.0.0",
		"rxjs": "7.8.2",
		"signature_pad": "5.1.1",
		"uuid": "^13.0.0",
		"zone.js": "^0.15.1"
	},
	"devDependencies": {
		"@angular/build": "^22.1.3",
		"@angular/cli": "^22.1.3",
		"@angular/compiler-cli": "22.1.0",
		"@types/crypto-js": "^4.2.2",
		"@types/jasmine": "^6.0.0",
		"@types/lodash": "4.17.20",
		"@types/node": "24.7.0",
		"@types/offscreencanvas": "^2019.7.3",
		"autoprefixer": "^10.4.21",
		"istanbul-lib-instrument": "^6.0.3",
		"jasmine-core": "^6.3.0",
		"karma": "^6.4.4",
		"karma-chrome-launcher": "^3.2.0",
		"karma-coverage": "^2.2.1",
		"karma-jasmine": "^5.1.0",
		"karma-jasmine-html-reporter": "^2.2.0",
		"postcss": "^8.5.6",
		"prettier": "3.6.2",
		"prettier-plugin-organize-imports": "4.3.0",
		"prettier-plugin-tailwindcss": "0.6.14",
		"tailwindcss": "^3.4.18",
		"tsx": "^4.22.4",
		"typescript": "^6.0.3"
	},
	"overrides": {
		"ngx-indexed-db": {
			"@angular/common": "$@angular/common",
			"@angular/core": "$@angular/core"
		},
		"@danielmoncada/angular-datetime-picker": {
			"@angular/common": "$@angular/common",
			"@angular/core": "$@angular/core",
			"@angular/cdk": "$@angular/cdk"
		}
	}
}
